import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { SubscriptionPlans } from './SubscriptionPlans'
import { FREE_VS_PREMIUM_FEATURES_ID } from 'modules/app/constants/index.js'

const messages = defineMessages({
  getPremiumTitle: {
    id: 'FreeVsPremiumFeatures.getPremiumTitle',
    defaultMessage: 'You have fitness goals, we help you achieve them.'
  }
})

/**
 * @param props
 * @param props.isReadOnly
 * @param props.areFeaturesPressable
 * @param props.shouldBoldMainFeatures
 * @return {Element}
 * @constructor
 */
export function FreeVsPremiumFeatures ({
  isReadOnly,
  areFeaturesPressable,
  shouldBoldMainFeatures
}) {
  const intl = useIntl()

  const style = {
    textAlign: 'center'
  }

  if (isReadOnly) {
    style.minHeight = 'auto'
  }

  return (
    <Block
      bgc='backgroundContent'
      style={style}
      id={FREE_VS_PREMIUM_FEATURES_ID}
    >
      <View centered>
        {
          !isReadOnly
            ? (
              <div style={{ margin: `0 ${STYLES_MARGIN.BIG} ${STYLES_MARGIN.BIG}` }}>
                <TextTitleCompressedHeavy>
                  {formatMessageIntlUtil(intl, messages.getPremiumTitle)}
                </TextTitleCompressedHeavy>
              </div>
              )
            : null
        }

        <SubscriptionPlans
          isReadOnly={isReadOnly}
          areFeaturesPressable={areFeaturesPressable}
          shouldBoldMainFeatures={shouldBoldMainFeatures}
        />
      </View>
    </Block>
  )
}

FreeVsPremiumFeatures.propTypes = {
  isReadOnly: PropTypes.bool,
  isSmallScreen: PropTypes.bool
}
